import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  results: {
    marginTop: theme.spacing(3),
  },
  informacoes: {
    paddingLeft: '20px',
    paddingRight: '20px',
  },
  divInformacao: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    padding: theme.spacing(1),
  },
}))

export default useStyles
